import React from "react";
import Topbar from "./components/Topbar";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import InfoStrip from "./components/InfoStrip";
import AIChannelCenter from "./components/AIChannelCenter";
import About from "./components/About";
import NetworkInfra from "./components/NetworkInfra";
import PatientCare from "./components/PatientCare";
import SubscriptionService from "./components/SubscriptionService";
import PersonalizedWellness from "./components/PersonalizedWellness";
import BookingConsultations from "./components/BookingConsultations";
import Approach from "./components/Approach";
import NewsAchievements from "./components/NewsAchievements";
import Partnerships from "./components/Partnerships";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="font-dm">
      <Topbar />
      <Navbar />
      <Hero />
      <InfoStrip />
      <About />
      <PatientCare />
      <NetworkInfra />
      <PersonalizedWellness />
      <BookingConsultations />
      <AIChannelCenter />
      <SubscriptionService />
      <Approach />
      <NewsAchievements />
      <Partnerships />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
